import { css } from "@emotion/core";
import { color, fontTypes, fontSizes } from "../../constants/commons";

export const inputFieldStyles = (capitaliseInput?: boolean) => css`
  @keyframes animateLine {
    0% {
      transform-origin: 0% 100%;
      transform: scaleX(0);
    }
    100% {
      transform-origin: 0% 100%;
      transform: scaleX(1);
    }
  }

  @-webkit-keyframes animateLine {
    0% {
      transform-origin: 0% 100%;
      transform: scaleX(0);
    }
    100% {
      transform-origin: 0% 100%;
      transform: scaleX(1);
    }
  }

  @-moz-keyframes animateLine {
    0% {
      transform-origin: 0% 100%;
      transform: scaleX(0);
    }
    100% {
      transform-origin: 0% 100%;
      transform: scaleX(1);
    }
  }

  position: relative;
  padding-top: 1.87em;
  width: 100%;
  .input-field {
    ${capitaliseInput && "text-transform: uppercase"};
    width: -webkit-fill-available;
    width: -moz-available;
    margin-bottom: auto;
    border: none;
    border-bottom: solid 0.5px ${color.lightishGray};
    text-align: start;
    font-family: ${fontTypes.bold};
    font-size: 1.14em;
    outline: none;
    z-index: 1;
    background: transparent;
    height: auto;
    color: ${color.black};
    border-radius: 0;
    position: relative;
    padding-bottom: 0.31em;
  }
  .input-field:disabled {
    border-bottom: solid 0.5px ${color.gray};
    color: ${color.lightishGray};
  }
  .floating-placeholder {
    font-family: ${fontTypes.bodyFont};
    font-size: 16px;
    letter-spacing: 0.25px;
    color: ${color.lightishGray};
    position: relative;
    bottom: 2em;
    display: inline;
  }
  .input-action {
    opacity: 0.8;
    font-weight: 500;
    letter-spacing: 0.25px;
    font-family: ${fontTypes.light};
    font-size: 0.63em;
    color: #646566;
    cursor: pointer;
    position: relative;
    bottom: 1.5em;
    float: right;
    z-index: 1;
  }
  .input-field-valid ~ .floating-placeholder,
  .input-field:focus ~ .floating-placeholder {
    pointer-events: none;
    bottom: 3.5em;
    position: relative;
    transition: 0.5s ease all;
    display: inline;
  }

  .input-field-valid,
  .input-field:focus {
    outline: none;
    background-color: none;
    border-bottom: solid 0.5px black;
    animation: animateLine 0.5s ease;
  }

  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type="number"] {
    -moz-appearance: textfield;
  }

  .validation-err-msg {
    position: absolute;
    bottom: 0px;
    color: ${color.orange};
    font-family: ${fontTypes.meduim};
    font-size: ${fontSizes.xs};
  }
`;
